/** @format */

'use strict';

angular.module('emsApp').controller('UserTypeDetailController', function($scope, $rootScope, $stateParams, $state, entity) {
	$scope.userType = entity;
	$scope.objectName = 'UserType';
	$scope.userTypeId = $stateParams.userTypeId;

	if (angular.isUndefined($rootScope.userTypeActiveTab)) {
		//set the default here
		$rootScope.userTypeActiveTab = 0;
	}

	$scope.goToEditState = function(userType) {
		$state.go('usertype.detail.edit({userTypeId:userType.id, mappedBy:mappedBy, mappedById:mappedById})');
	};

	// by broadcasting this event from an edit dialog the model is refreshed
	$rootScope.$on('emsApp:userTypeUpdate', function(event, result) {
		$scope.userType = result;
	});
});
